import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ChevronDownIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M1.437,3.164 C1.48109554,3.14866667 3.50709554,5.242 7.515,9.444 L14.023,3.141 L15.414,4.577 L7.47,12.274 L1.77635684e-15,4.554 C0.91390446,3.64266667 1.39290446,3.17933333 1.437,3.164 Z"
        data-testid="icon-chevronDown"
        fill={customColour}
        className={styles[className]}
      />
    </Icon>
  )
}
